import {ActionTypes as Types} from './types'

const EventsState = {
}

export const eventsReducer = (state = EventsState, action) => {
    switch (action.type) {
        default:
            return state
    }
}
